import ColorPickerButton from 'molecules/ColorPickerButton'
import ColorBucketIcon from 'atoms/icons/ColorBucketIcon'
import { ItemData, ItemDataShapeProps } from 'store/types'
import ShapesIcon from 'atoms/icons/ShapesIcon'
import SelectIconModal from 'molecules/SelectIconModal'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = {
  item: ItemData<'shape'>
  onPropsChange: (props: ItemDataShapeProps) => void
}

function PostShapeTools({ item, onPropsChange }: Props) {
  const [selectShapesModalOpen, setSelectShapesModalOpen] = useState(false)
  return (
    <>
      <div className='flex flex-col gap-2'>
        <div className='flex flex-row flex-wrap gap-2'>
          <button className='btn btn-sm btn-outline' onClick={() => setSelectShapesModalOpen(true)}>
            <ShapesIcon size={18} />
          </button>
          <ColorPickerButton
            leftElement={<ColorBucketIcon size={18} />}
            color={item.props.color}
            onChangeColor={color =>
              onPropsChange({
                ...item.props,
                color
              })
            }
          />
        </div>
        <div className='flex items-center justify-center'>
          <FontAwesomeIcon icon={item.props.icon} size='10x' color={item.props.color} />
        </div>
      </div>
      <SelectIconModal
        open={selectShapesModalOpen}
        onClose={() => setSelectShapesModalOpen(false)}
        onConfirm={(name, icon) => {
          setSelectShapesModalOpen(false)
          onPropsChange({
            ...item.props,
            name,
            icon
          })
        }}
      />
    </>
  )
}

export default PostShapeTools
